import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridComplaintsResponsesComponent } from './grid-complaints-responses.component';
import {AgGridModule} from 'ag-grid-angular';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule
  ],
  declarations: [GridComplaintsResponsesComponent],
  exports: [GridComplaintsResponsesComponent],
})
export class GridComplaintsResponsesModule { }



// WEBPACK FOOTER //
// ./src/app/utils/grid-complaints-responses/grid-complaints-responses.module.ts